import { useCallback, useState } from 'react';
import S from './SimpleImageDetail.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function SimpleImageDetail(props) {
  const {
    rsrc,
    src,
    loading: pLoading
  } = props;
  const [loading, setLoading] = useState(true);
  const onLoad = useCallback(() => {
    setLoading(false);
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: S.imageViewer,
    children: [(loading || pLoading) && /*#__PURE__*/_jsx("div", {
      className: S.loader,
      children: /*#__PURE__*/_jsx("i", {
        className: "fa fa-fw fa-spin fa-spinner fa-3x"
      })
    }), /*#__PURE__*/_jsx("img", {
      loading: "lazy",
      onLoad: onLoad,
      className: S.image,
      src: src,
      alt: rsrc?.data?.path
    })]
  });
}